angular.module 'zc.master'

.controller 'MasterAgenciesEditCtrl', (
    $scope,
    $state,
    $translate,
    Page,
    MasterAgency,
    agency,
    users,
    shoppingCartAsps,
    invoiceCalculationTypes,
    invoiceIssueDays,
    invoicePaymentDays,
    invoicePaymentMonths,
    salesEntities) ->
  Page.setBodyClass ''
  $translate('masterAgencies.edit.editAgencies').then (translation) ->
    Page.setTitle translation

  $scope.agency = agency
  $scope.shoppingCartAsps = shoppingCartAsps
  $scope.invoiceCalculationTypes = invoiceCalculationTypes
  $scope.invoiceIssueDays = invoiceIssueDays
  $scope.invoicePaymentDays = invoicePaymentDays
  $scope.invoicePaymentMonths = invoicePaymentMonths
  $scope.salesEntities = salesEntities
  $scope.users = users

  $scope.save = (agency) ->
    if agency.id
      promise = MasterAgency.update(agency)
    else
      promise = MasterAgency.create(agency)
    promise.then ->
      $state.go 'admin.master.agencies'



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.agencies/edit.controller.coffee